module.exports = __webpack_public_path__ + "kreislauf.34229d59bc52d0183decca4cacbdaaa5.png";